export const BattleIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.59485 3L4.43619 6.47708L9.86872 11.7606L7.84097 13.9847L7.13438 13.2513L5.94468 14.4805L6.69071 15.2513L4.58079 17.5637L4.1897 17.163L3 18.3922L5.52401 21L6.71371 19.7708L6.32262 19.3667L8.56399 17.1902L9.31002 17.9576L10.4997 16.7284L9.79314 15.9983L12.0082 13.8387L14.2167 15.9881L13.5003 16.7284L14.69 17.9576L15.4426 17.18L17.684 19.3565L17.283 19.7708L18.476 21L21 18.3922L19.8103 17.163L19.4291 17.5569L17.3192 15.2411L18.0553 14.4805L16.8656 13.2513L16.1656 13.9745L14.1477 11.7606L14.151 11.7572L12.0082 9.41087L6.9602 3.86927L3.59485 3ZM20.4216 3L17.0562 3.86927L12.9777 8.34465L15.2454 10.691L19.5802 6.47708L20.4216 3Z"
        className="oui-fill-base-contrast-80"
      />
    </svg>
  );
};
